import { Collapse, Divider, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Repeat } from "lib/@components/repeat"
import { navigate } from "lib/routes/navigate"
import Iconify from "minimals-template/components/Iconify"
import { getCurrencySymbol } from "../format-utils"
import { RateCardTradeHeader } from "./rate-card-trade-header"
import { RateCardTradeRow } from "./rate-card-trade-row"

export function RateCardPreview({ rateCard, expanded, onToggleExpand }) {
    const lines = rateCard?.lines ?? []
    const currencySymbol = getCurrencySymbol(rateCard?.currency)

    return (
        <Stack spacing={1}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="subtitle2">{rateCard?.name}</Typography>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <If value={rateCard?.id}>
                        <Tooltip title="Edit rate card">
                            <IconButton size="small" onClick={handleEdit} data-cy="edit-rate-card">
                                <Iconify icon="eva:edit-outline" />
                            </IconButton>
                        </Tooltip>
                    </If>
                    <IconButton
                        aria-label={expanded ? "Collapse rate card" : "Expand rate card"}
                        size="small"
                        onClick={onToggleExpand}
                    >
                        <Iconify icon={expanded ? "mdi:chevron-up" : "mdi:chevron-down"} />
                    </IconButton>
                </Stack>
            </Stack>
            <Collapse in={expanded}>
                <Stack spacing={0}>
                    <RateCardTradeHeader currencySymbol={currencySymbol} />
                    <Divider />
                    <Repeat list={lines} item={<RateCardTradeRow currencySymbol={currencySymbol} />} />
                </Stack>
            </Collapse>
        </Stack>
    )

    function handleEdit() {
        if (!rateCard?.id) return
        navigate(`/app/optimiser/rate-cards/${rateCard.id}`)
    }
}
